import axios from 'axios';

const Payment = {
    namespaced: true,    
    actions: {
        VerifySubscription(context,PaymentReference) {
            return new Promise((resolve, reject) => {  
                                  
                axios.get(`${process.env.VUE_APP_ENV_API_URL}Payment/VerifySubscription?PaymentReference=${PaymentReference}`)
                    .then(resp => resp.data)
                    .then(data => {                       
                        resolve(data)
                    })
                    .catch(err => {                       
                        reject(err)
                    })
            })
        },           
    },
}

export default Payment